<template>
  <div class="rewards-page">
    <div class="rewards-container">
      <div class="head">
        <div class="label">{{ $t(`${i18nPrefix}.label.rewards`) }}</div>
      </div>
      <div class="content">
        <Elc v-if="isElcEmployee"></Elc>
        <Common v-else ref="rewards"></Common>
      </div>
    </div>
  </div>
</template>

<script>
import Common from './common'
import Elc from './custom/elc.vue'
export default {
  components: {
    Common,
    Elc
  },
  props: {
    personalInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.rewards'
    }
  },
  computed: {
    employeeInfo () {
      return this.personalInfo.employee
    },
    isElcEmployee () {
      return this.employeeInfo?.company?.root_company.id === 6172
    }
  },
  mounted () {
    this.$el.parentElement.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    this.$el.parentElement.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (e) {
      const element = e.srcElement
      if (element.scrollTop + element.offsetHeight + 50 >= element.scrollHeight) {
        const ref = this.$refs.rewards
        if (ref && ref.handleScroll) {
          ref.handleScroll()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rewards-page {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);

  .head {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }
  }

  .content {
    min-height: calc(100vh - 80px - var(--header-height));
    min-height: calc(100dvh - 80px - var(--header-height));
    padding: 24px 40px;
    background-color: #fff;
  }
}
</style>
